<script lang="ts">
export default {
  name: 'DataQualityRollupEntityRow',
};
</script>

<script setup lang="ts">
import { DataQualityRollupEntity, DataQualityRule } from '@/types/DataQuality';

const props = defineProps({
  header: Boolean,
  violation: Object as () => DataQualityRollupEntity,
  policyTypeRules: Array as () => Readonly<DataQualityRule[]>,
  issuingCompanyRules: Array as () => Readonly<DataQualityRule[]>,
  wholesalerRules: Array as () => Readonly<DataQualityRule[]>,
});

function violatedRules(rollupEntity: DataQualityRollupEntity): (DataQualityRule & { violated: boolean })[] {
  let rules;
  switch (rollupEntity.entityType) {
    case 'Policy Type':
      rules = props.policyTypeRules;
      break;
    case 'Issuing Company':
      rules = props.issuingCompanyRules;
      break;
    case 'Wholesaler':
      rules = props.wholesalerRules;
      break;
    default:
      rules = [];
  }

  if (!rules) return [];
  return rules.map(rule => ({
    ...rule,
    violated: Reflect.get(rollupEntity, `rule${rule.value}`) > 0,
  }));
}
</script>

<template>
  <tr>
    <template v-if="header">
      <td class="nosort tw:w-[30%]">Entity</td>
      <td class="nosort tw:w-[55%]">Entity Type</td>
      <td class="nosort tw:w-[15%]">Violations</td>
      
    </template>
    <template v-else-if="violation">
      <td class=" tw:w-[30%]">{{ violation.entity }}</td>
      <td class=" tw:w-[55%]">{{ violation.entityType }}</td>
      <td class=" tw:w-[15%]">
        <div class="tw:inline-block" v-for="(rule) in violatedRules(violation)" :key="rule.key">
          <v-tooltip location="bottom" v-if="rule.violated">
            <template v-slot:activator="{ props }">
              <span v-bind="props" class="tw:flex tw:bg-primary tw:w-5 tw:h-5 tw:text-white 
                                          tw:mr-0.5 tw:rounded-full tw:text-[10pt] tw:font-bold 
                                          tw:justify-center tw:items-center tw:scale-[85%] tw:cursor-pointer">
                <span class="tw:w-fit tw:h-fit tw:font-mono">{{ rule.value }}
                </span>
              </span>
            </template>
            <h4>Rule</h4>
            <p>{{ rule.desc }}</p>
            <h4>Resolution</h4>
            <p>{{ rule.resolution }}</p>
          </v-tooltip>
        </div>
      </td>
    </template>
  </tr>
</template>
